import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { enviroments } from 'utils/constants';
import { getLocalStorageLanguage } from 'utils/utils';

const CURRENT_LANGUAGE = getLocalStorageLanguage();

export const noticesServiceApi = createApi({
  reducerPath: 'noticesServiceApi',
  baseQuery: fetchBaseQuery({
    baseUrl: enviroments.endPoint,
    prepareHeaders: (headers, { getState, endpoint }) => {
      headers.set(
        'Authorization',
        'Bearer ' + JSON.parse(localStorage.getItem('userAccountInformation') || '{}').bearerToken,
      );
      return headers;
    },
  }),
  endpoints: (builder) => ({
    GetNotices: builder.query<any, any>({
      query: ({language = CURRENT_LANGUAGE, pageNumber = 1, elementsPerPage, categoryId, showMain}) => `notice/?${categoryId && `categories=${categoryId}&`}locale=${language}&pageNumber=${pageNumber}&elementsPerPage=${elementsPerPage}&showMain=${showMain}`,
    }),
    GetMainNotice: builder.query<any, any>({
      query: ({ language = CURRENT_LANGUAGE }) => `notice/main?locale=${language}`,
    }),
  }),
});

export const {
  useLazyGetMainNoticeQuery,
  useLazyGetNoticesQuery,
} = noticesServiceApi;
